(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-template"]) return;
  try {
    
$(document).ready(function () {
  $('#clear-cart').click(function (e) {
    e.preventDefault();
    $('.quick-order-quantity').val('0');
    $('.quick-order-quantity').trigger('change');
    $.ajax({
      type: 'POST',
      url: '/cart/clear.js',
      async: false
    });
    document.location.reload();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quick-order-variants"]) return;
  try {
    
$(document).ready(function () {
  function updateTotal() {
    var subtotal = 0;
    $('.quick-order-quantity').each(function (idx, ele) {
      var price = 0;
      var qty = parseInt($(ele).val());
      if(isNaN(qty)) {
        qty = 0;
      }
      if($(this).closest('tr').find('.product-selector-checkbox').is(':checked')) {
        price = parseInt($(ele).closest('tr').find('.product-selector-checkbox').parent().attr('data-price'));
      } else {
        price = parseInt($(ele).closest('tr').find('.product-selector:checked').parent().attr('data-price'));
      }
      var itemTotal = qty * price;
      subtotal = itemTotal + subtotal;
    });
    $('.total-subtotal').text('$' + (subtotal / 100.0).toFixed(2));
  }

  $('.product-selector').change(function () {
    if($(this).val() == '3') {
      $(this).parent().parent().find('.product-selector-checkbox').prop('disabled', false);
    } else {
      $(this).parent().parent().find('.product-selector-checkbox').prop('disabled', true);
      $(this).parent().parent().find('.product-selector-checkbox').prop('checked', false);
    }
    if(parseInt($(this).closest('tr').find('.quick-order-quantity').val()) == 0) {
      $(this).closest('tr').find('.quick-order-quantity').val('1');
    }
    $(this).closest('tr').find('.quick-order-quantity').trigger('change');
  });
  $('.product-selector-checkbox').change(function () {
    $(this).closest('tr').find('.quick-order-quantity').trigger('change');
  });

  $('.quick-order-quantity').change(function () {
    var qty = parseInt($(this).val());
    if(isNaN(qty)) {
      qty = 0;
    }
    var price = 0;
    if($(this).closest('tr').find('.product-selector-checkbox').is(':checked')) {
      price = parseInt($(this).closest('tr').find('.product-selector-checkbox').parent().attr('data-price'));
    } else {
      price = parseInt($(this).closest('tr').find('.product-selector:checked').parent().attr('data-price'));
    }

    var subtotal = (qty * price) / 100.0;
    $(this).closest('tr').find('.subtotal').text('$' + subtotal.toFixed(2));
    updateTotal();
  });

  $('#clear-cart').click(function (e) {
    e.preventDefault();
    $('.quick-order-quantity').val('0');
    $('.quick-order-quantity').trigger('change');
  });

  $('#place-order').click(function (e) {
    e.preventDefault();

    var orderItems = [];
    $('.quick-order-quantity').each(function (idx, ele) {
      var variantId = $(ele).closest('tr').attr('data-variant-id');
      if($(ele).closest('tr').find('.product-selector-checkbox').is(':checked')) {
        variantId = parseInt($(ele).closest('tr').find('.product-selector-checkbox').parent().attr('data-variant-id'));
      } else {
        variantId = parseInt($(ele).closest('tr').find('.product-selector:checked').parent().attr('data-variant-id'));
      }

      if(parseInt($(ele).val()) > 0) {
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: {
            quantity: $(ele).val(),
            id: variantId,
            properties: {
              'Source': window.quickorderNote
            }
          },
          async: false
        });
      }
    });
    $('.product-selector[value=0]').click();
    $('.quick-order-quantity').val('0');
    $('.subtotal,.total-subtotal').text('$0.00');
    $.getJSON('/cart.json', function(data) {
      try {
        refreshCart(data);
      } catch(err) {}
      $('.cart-button').click();
    });
  });

  $('.quick-order-quantity').each(function (idx, ele) {
    $(ele).trigger('change');
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quick-order"]) return;
  try {
    
$(document).ready(function () {
  function updateTotal() {
    var subtotal = 0;
    $('.quick-order-quantity').each(function (idx, ele) {
      var qty = parseInt($(this).val());
      if(isNaN(qty)) {
        qty = 0;
      }
      var itemTotal = qty * parseInt($(this).closest('tr').attr('data-price'));
      subtotal = itemTotal + subtotal;
    });
    $('.total-subtotal').text('$' + (subtotal / 100.0).toFixed(2));
  }

  $('.quick-order-quantity').change(function () {
    var qty = parseInt($(this).val());
    if(isNaN(qty)) {
      qty = 0;
    }
    if(window.stockOrder) {
      if(qty > parseInt($(this).attr('data-max'))) {
        $(this).val($(this).attr('data-max'));
        qty = parseInt($(this).attr('data-max'));
        console.log('test');
        console.log(qty);
      }
    }
    var price = parseInt($(this).closest('tr').attr('data-price'));
    var subtotal = (qty * price) / 100.0;
    $(this).closest('tr').find('.subtotal').text('$' + subtotal.toFixed(2));
    updateTotal();
  });
  $('#clear-cart').click(function (e) {
    e.preventDefault();
    $('.quick-order-quantity').val('0');
    $('.quick-order-quantity').trigger('change');
  });

  $('#place-order').click(function (e) {
    e.preventDefault();

    var orderItems = [];
    $('.quick-order-quantity').each(function (idx, ele) {
      if(parseInt($(ele).val()) > 0) {
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: {
            quantity: $(ele).val(),
            id: $(ele).closest('tr').attr('data-variant-id'),
            properties: {
              'Source': window.quickorderNote
            }
          },
          async: false
        });
      }
    });
    $('.quick-order-quantity').val('0');
    $('.subtotal,.total-subtotal').text('$0.00');
    $.getJSON('/cart.json', function(data) {
      try {
        refreshCart(data);
      } catch(err) {}
      $('.cart-button').click();
    });
  });

  $('.quick-order-quantity').each(function (idx, ele) {
    $(ele).trigger('change');
  });
});

  } catch(e) { console.error(e); }
})();
})();
